module.exports = __webpack_public_path__ + "img/cb-r-rr1.46702373.gif";